module.exports = __webpack_public_path__ + "img/iconmonstr-plus-circle-thin.2c917159.svg";